import React, { PropTypes } from 'react';
import ManipButtons from '../ManipButtons';
import { getConso } from '../../reducers/manip';

const RatItem = ({ manip, onUpdated, onDeleted, disabled = false }) => (
  <tr>
    <ManipButtons
      manip={manip}
      onUpdated={onUpdated}
      onDeleted={onDeleted}
      hideHistory={false}
      disabled={disabled}
    />
    <td>{manip.number}</td>
    <td>{manip.product_name}</td>
    <td>{manip.manip_name}</td>
    <td>{manip.comp_product_name}</td>
    <td>{manip.comp_manip_name}</td>
    <td>{getConso(manip)}</td>
    <td>{manip.captures}</td>
  </tr>
);

RatItem.propTypes = {
  manip: PropTypes.object.isRequired,
  onUpdated: PropTypes.func.isRequired,
  onDeleted: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default RatItem;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/components/types/RatItem.js